export default __webpack_public_path__ + "static/media/hotel-out-4.bdf77537.jpg";